/* VuRoot Theme — global JS */
(function() {
  'use strict';

  // Smooth-scroll for in-page anchors
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href.length <= 1) return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Update cart count in header on add-to-cart submissions
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;
    // Let Shopify handle the form natively — count updates after page navigation.
  });
})();
